import { render, staticRenderFns } from "./opinionConfirm.vue?vue&type=template&id=b5c4deb2&scoped=true&"
import script from "./opinionConfirm.vue?vue&type=script&lang=js&"
export * from "./opinionConfirm.vue?vue&type=script&lang=js&"
import style0 from "./opinionConfirm.vue?vue&type=style&index=0&id=b5c4deb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c4deb2",
  null
  
)

export default component.exports